import React, { useState, useEffect } from "react";
import { Typography, Card, Carousel, Table } from "antd";
import * as MartHealthDashboardActions from "../../redux/actions/martHealthDashboard.actions";
import * as AuthActions from "../../redux/actions/auth.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import Pageloader from "../../components/loader";
import io from 'socket.io-client';
import moment from "moment";
import { MartHealthDashboardStoreEmails } from "../../utils/Helpers";

const { Title } = Typography;
const socket = io(process.env.REACT_APP_ROCKY_SOCKET_URL);

const MartHealthDashboard = (props) => {
  const pagename = "Mart Health Dashboard";
  const [loading, setLoading] = useState(true);
  const [updatedAtONP, setupdatedAtONP] = useState();

  useEffect(() => {
    socket.on('MART_HEALTH_DASHBOARD_REFRESH', (data) => {
      marthealthDashboardList();
    });
    marthealthDashboardList();
    return () => {
        socket.off('MART_HEALTH_DASHBOARD_REFRESH');
    };
  }, []);

  useEffect(() => {
    props.AuthActions.navbarCollapsedAction(true);
  }, []); 

  useEffect(() => {
    orderNotPackedList();
    const intervalId = setInterval(orderNotPackedList, 300000); // 300,000 ms = 5 minutes
    return () => clearInterval(intervalId);
  }, []); 

  const orderNotPackedList = async () => {
    try {
      // setLoading(true);
      setupdatedAtONP(moment().format("hh:mm a"))
      await props.MartHealthDashboardActions.getOrderNotPartialListAction(MartHealthDashboardStoreEmails[props.user.email]);
    } catch (e) {} finally {
      // setLoading(false);
    }
  };
  
  const marthealthDashboardList = async () => {
    try {
      // console.log("MartHealthDashboardStoreEmails: ",MartHealthDashboardStoreEmails[props.user.email]);
      setLoading(true);
      await props.MartHealthDashboardActions.getMartHealthDashboardListAction(MartHealthDashboardStoreEmails[props.user.email]);
    } catch (e) {} finally {
      setLoading(false);
    }
  };

  const ONPColumns = [
    {
      title: 'Order Id',
      key: 'order_id',
      fontSize: "1.0rem",
      render: (record) => record?.order_id || 'N/A',
    },
    {
      title: 'Created Time',
      key: 'order_id',
      fontSize: "1.0rem",
      render: (record) => moment(record?.createdAt).format("DD MMM, yyyy hh:mm A") || 'N/A',
    },
  ];

  const columns = [
    {
      title: 'Item',
      key: 'product_name',
      fontSize: "1.0rem",
      render: (record) => {
        if (record.payload?.Title) {
          return record.payload.Title;
        } else if (record.payload?.Product_name) {
          return record.payload.Product_name;
        } else if (record.payload?.ProductName) {
          return record.payload.ProductName;
        }
        return 'N/A';
      }
    },
    {
      title: 'Qty',
      key: 'Quantity',
      width: 60,
      fontSize: "1.0rem",
      render: (record) => {
        if (record.payload?.Quantity) {
          return parseInt(record.payload.Quantity);
        } else if (record.payload?.PartialQuantity) {
          return parseInt(record.payload.PartialQuantity);
        } else if (record.payload?.Physical_inventory) {
          return parseInt(record.payload.Physical_inventory);
        }
        return 'N/A';
      }
    }
  ];

  // console.log(props.orderNotPartialData)

  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={1}>{pagename}</Title>
        </div>
      </div>
      <div className="p-content">
        {/* {loading == true ? <Pageloader /> : */}
          <>
            <div style={{ padding: "14px" }}>
              <Carousel
                autoplay={true}
                autoplaySpeed={10000}
                // dots
                infinite={true} 
                draggable
                slidesToShow={3} // Show 3 full cards and part of the 4th card
                slidesToScroll={1}
              >
                <div key={100}>
                  <Card
                    title={<span style={{ fontSize: '1.2rem' }}>Orders Not Packed <span style={{ color: "#999", display: "block" }}>Last Updated At: {updatedAtONP}</span></span>}
                    bordered={false}
                    bodyStyle={{ padding: 0 }}
                    headStyle={{ padding: 0, border: "none" }}
                    style={{
                      borderRadius: "12px",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                      height: "550px",
                      paddingLeft: "12px",
                      paddingRight: "12px",
                      marginRight: "1rem",
                      marginBottom: "1rem",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Table
                      pagination={false}
                      dataSource={props.orderNotPartialData}
                      columns={ONPColumns}
                      className="mart-health-table"
                      scroll={{
                        y: 400,
                      }}
                      style={{
                        fontSize: "0.9rem"
                      }}
                    />
                  </Card>
                </div>
                {
                  props.martHealthDashboardListData.length > 0 &&
                  props.martHealthDashboardListData.map((list, index) => (
                    <div key={index}>
                      <Card
                        title={<span style={{ fontSize: '1.2rem' }}><span style={{ textTransform: 'capitalize' }}>{list.title}
                        </span> {list.updated_time && <span style={{ color: "#999", display: "block" }}>Last Updated At: {moment(list.updated_time).format("hh:mm a")}</span>}</span>}
                        bordered={false}
                        bodyStyle={{ padding: 0 }}
                        headStyle={{ padding: 0, border: "none" }}
                        style={{
                          borderRadius: "12px",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                          height: "550px",
                          paddingLeft: "12px",
                          fontSize: "11px",
                          paddingRight: "12px",
                          marginBottom: "1rem",
                          marginRight: "1rem",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >

                        <Table
                          pagination={false}
                          cellPaddingBlock={0}
                          dataSource={list.mart_health_dashboard_pivots_result}
                          columns={columns}
                          className="mart-health-table"
                          scroll={{
                            y: 400,
                          }}
                        />
                      </Card>
                    </div>
                  ))
                }
              </Carousel>
            </div>
          </>
        {/* } */}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    orderNotPartialData: state.MartHealthDashboardReducer.orderNotPartialData,
    martHealthDashboardListData: state.MartHealthDashboardReducer.martHealthDashboardListData,
    user: state.authReducer.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    MartHealthDashboardActions: bindActionCreators(MartHealthDashboardActions, dispatch),
    AuthActions: bindActionCreators(AuthActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MartHealthDashboard);